export interface StackBodySnapshot {
  bottomY: number;
  placed: boolean;
  supportConnected: boolean;
}

export interface PlacementScore {
  extensionPx: number;
  extensionBonus: number;
  total: number;
}

export function formatScore(score: number): string {
  const normalized = Object.is(score, -0) ? 0 : Math.trunc(score);
  return `${normalized.toLocaleString('ja-JP')}点`;
}

export function placedStackBottom(bodies: readonly StackBodySnapshot[], supportBottomY = 0): number {
  let bottom = supportBottomY;
  for (const body of bodies) {
    if (body.placed && body.supportConnected) {
      bottom = Math.max(bottom, body.bottomY);
    }
  }
  return bottom;
}

export function calculatePlacementScore(
  baseScore: number,
  previousBottomY: number,
  currentBottomY: number,
): PlacementScore {
  const extensionPx = Math.max(0, currentBottomY - previousBottomY);
  const extensionBonus = Math.min(120, Math.max(0, Math.round(extensionPx * 0.8)));
  return { extensionPx, extensionBonus, total: -(Math.round(baseScore) + extensionBonus) };
}
